var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "flex justify-end"
  }, [_c('ul', {
    staticClass: "pagination"
  }, [_c('li', {
    staticClass: "pagination-item"
  }, [_vm.isInFirstPage ? _c('span', {
    staticClass: "flex w-8 h-8 justify-center items-center cursor-not-allowed no-underline opacity-30 text-sm"
  }, [_c('img', {
    staticClass: "w-4",
    attrs: {
      "src": require("@/assets/images/icons/chevron-double-left.svg")
    }
  })]) : _c('a', {
    staticClass: "flex w-8 h-8 justify-center items-center text-sm text-gray-600 hover:bg-gray-100 no-underline",
    attrs: {
      "href": "#",
      "role": "button",
      "rel": "prev"
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.onClickFirstPage.apply(null, arguments);
      }
    }
  }, [_c('img', {
    staticClass: "w-4",
    attrs: {
      "src": require("@/assets/images/icons/chevron-double-left.svg")
    }
  })])]), _c('li', {
    staticClass: "pagination-item"
  }, [_c('button', {
    staticClass: "flex w-8 h-8 justify-center items-center hover:bg-gray-100 no-underline text-sm",
    class: {
      'cursor-not-allowed opacity-30': _vm.isInFirstPage
    },
    attrs: {
      "type": "button",
      "disabled": _vm.isInFirstPage,
      "aria-label": "Go to previous page"
    },
    on: {
      "click": _vm.onClickPreviousPage
    }
  }, [_c('img', {
    staticClass: "w-4",
    attrs: {
      "src": require("@/assets/images/icons/chevron-left.svg")
    }
  })])]), _vm._l(_vm.pages, function (page) {
    return _c('li', {
      key: page.name,
      staticClass: "pagination-item"
    }, [_vm.isPageActive(page.name) ? _c('span', {
      staticClass: "rounded flex w-8 h-8 justify-center items-center bg-primary-500 no-underline text-white cursor-not-allowed font-bold mx-1 text-sm"
    }, [_vm._v(" " + _vm._s(page.name) + " ")]) : _c('a', {
      staticClass: "rounded flex w-8 h-8 justify-center items-center hover:bg-gray-100 text-neutral-600 no-underline mx-1 text-sm",
      attrs: {
        "href": "#",
        "role": "button"
      },
      on: {
        "click": function ($event) {
          $event.preventDefault();
          return _vm.onClickPage(page.name);
        }
      }
    }, [_vm._v(" " + _vm._s(page.name) + " ")])]);
  }), _c('li', {
    staticClass: "pagination-item"
  }, [_c('button', {
    staticClass: "rounded flex w-8 h-8 justify-center items-center hover:bg-gray-100 text-gray-600 no-underline text-sm",
    class: {
      'cursor-not-allowed opacity-30': _vm.isInLastPage
    },
    attrs: {
      "type": "button",
      "disabled": _vm.isInLastPage,
      "aria-label": "Go to next page"
    },
    on: {
      "click": _vm.onClickNextPage
    }
  }, [_c('img', {
    staticClass: "w-4",
    attrs: {
      "src": require("@/assets/images/icons/chevron-right.svg")
    }
  })])]), _c('li', {
    staticClass: "pagination-item"
  }, [_vm.hasMorePages ? _c('a', {
    staticClass: "rounded flex w-8 h-8 justify-center items-center hover:bg-gray-100 text-gray-600 no-underline text-sm",
    class: {
      'cursor-not-allowed opacity-30': _vm.isInLastPage
    },
    attrs: {
      "href": "#",
      "rel": "next",
      "role": "button"
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.onClickLastPage.apply(null, arguments);
      }
    }
  }, [_c('img', {
    staticClass: "w-4",
    attrs: {
      "src": require("@/assets/images/icons/chevron-double-right.svg")
    }
  })]) : _c('span', {
    staticClass: "rounded flex w-8 h-8 justify-center items-center hover:bg-gray-100 text-gray-600 no-underline cursor-not-allowed opacity-30 text-sm"
  }, [_c('img', {
    staticClass: "w-4",
    attrs: {
      "src": require("@/assets/images/icons/chevron-double-right.svg")
    }
  })])])], 2)]);

}
var staticRenderFns = []

export { render, staticRenderFns }